export default "__VITE_ASSET__da989b19__"